module.exports = __webpack_public_path__ + "img/faming2.82626265.png";